// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.simx-list-filter-panel--body-toggle {
  appearance: none;
  background: none;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  font-family: "Quicksand";
  font-size: 0.875rem;
  font-weight: 400;
  margin: 0;
  padding: 0;
  text-align: left;
  width: 100%;
}
.simx-list-filter-panel--body-toggle .simx-filter-icon {
  flex-grow: 0;
  flex-shrink: 0;
  margin: 0 6px 0 12px;
  width: 14px;
  height: 14px;
}
.simx-list-filter-panel--body-toggle .simx-filter-icon path {
  fill: rgb(159.1666666667, 178.3333333333, 178.3333333333);
}
.simx-list-filter-panel--body-toggle .simx-toggle-icon {
  margin: 0 16px 0 6px;
  width: 14px;
  height: 14px;
  transform: scaleX(1.2) scaleY(1);
  transition: transform 0.2s;
}
.simx-list-filter-panel.simx-expanded .simx-list-filter-panel--body-toggle .simx-toggle-icon {
  transform: scaleX(1.2) scaleY(-1);
}
.simx-list-filter-panel--body-toggle .simx-toggle-icon path {
  fill: rgb(159.1666666667, 178.3333333333, 178.3333333333);
}

.simx-list-filter-panel--body-toggle--heading {
  flex-grow: 1;
  padding: 8px;
}
.simx-list-filter-panel--body-toggle--heading .simx-filter-value {
  font-weight: 600;
}

.simx-list-filter-panel--body {
  padding: 0 12px;
}

.simx-list-filter-panel--body-inner {
  border-top: solid 1px rgb(194.5833333333, 206.6666666667, 206.6666666667);
  padding: 12px 0;
}

.simx-list-filter-panel--filter-attribute-block {
  display: flex;
  align-items: center;
  margin: 10px 0;
}
.simx-list-filter-panel--filter-attribute-block:first-of-type {
  margin-top: 0;
}
.simx-list-filter-panel--filter-attribute-block:last-of-type {
  margin-bottom: 0;
}

.simx-list-filter-panel--filter-attribute-label-block {
  flex-grow: 0;
  flex-shrink: 0;
  padding-right: 12px;
  width: 20%;
}

.simx-list-filter-panel--filter-attribute-label {
  display: block;
  font-size: 0.875rem;
  font-weight: 600;
}

.simx-list-filter-panel--filter-attribute-value-block {
  flex-grow: 1;
  font-size: 0.875rem;
  padding-left: 12px;
}
.simx-list-filter-panel--filter-attribute-value-block .simx-text-input {
  font-size: 0.875rem;
  width: 100%;
}
.simx-list-filter-panel--filter-attribute-value-block .simx-select {
  font-size: 0.875rem;
}

.simx-list-filter-panel--filter-attribute-action-block {
  padding-left: 12px;
  width: 34px;
}`, "",{"version":3,"sources":["webpack://./src/app/modules/ui-elements/components/elements/list-filter-panel/list-filter-panel.component.scss","webpack://./src/assets/styles/_fonts.scss","webpack://./src/assets/styles/_colors.scss"],"names":[],"mappings":"AAIA;EACE,gBAAA;EACA,gBAAA;EACA,YAAA;EACA,eAAA;EACA,aAAA;EACE,mBAAA;EACF,wBCVgB;EDWhB,mBAAA;EACA,gBAAA;EACA,SAAA;EACA,UAAA;EACA,gBAAA;EACA,WAAA;AAHF;AAKE;EACE,YAAA;EACA,cAAA;EACA,oBAAA;EACA,WAAA;EACA,YAAA;AAHJ;AAKI;EACE,yDEb0B;AFUhC;AAOE;EACE,oBAAA;EACA,WAAA;EACA,YAAA;EACA,gCAAA;EACA,0BAAA;AALJ;AAOI;EACE,iCAAA;AALN;AAQI;EACE,yDE7B0B;AFuBhC;;AAWA;EACE,YAAA;EACA,YAAA;AARF;AAUE;EACE,gBAAA;AARJ;;AAYA;EACE,eAAA;AATF;;AAYA;EACE,yEAAA;EACA,eAAA;AATF;;AAYA;EACE,aAAA;EACE,mBAAA;EACF,cAAA;AATF;AAUE;EACE,aAAA;AARJ;AAUE;EACE,gBAAA;AARJ;;AAYA;EACE,YAAA;EACA,cAAA;EACA,mBAAA;EACA,UAAA;AATF;;AAYA;EACE,cAAA;EACA,mBAAA;EACA,gBAAA;AATF;;AAYA;EACE,YAAA;EACA,mBAAA;EACA,kBAAA;AATF;AAWE;EACE,mBAAA;EACA,WAAA;AATJ;AAWE;EACE,mBAAA;AATJ;;AAaA;EACE,kBAAA;EACA,WAAA;AAVF","sourcesContent":["@use 'colors';\n@use 'fonts';\n@use 'theme';\n\n.simx-list-filter-panel--body-toggle {\n  appearance: none;\n  background: none;\n  border: none;\n  cursor: pointer;\n  display: flex;\n    align-items: center;\n  font-family: fonts.$simxFontGraphic;\n  font-size: 0.875rem;\n  font-weight: 400;\n  margin: 0;\n  padding: 0;\n  text-align: left;\n  width: 100%;\n\n  .simx-filter-icon {\n    flex-grow: 0;\n    flex-shrink: 0;\n    margin: 0 6px 0 12px;\n    width: 14px;\n    height: 14px;\n\n    path {\n      fill: colors.$simxColorLightNeutralDarker;\n    }\n  }\n\n  .simx-toggle-icon {\n    margin: 0 16px 0 6px;\n    width: 14px;\n    height: 14px;\n    transform: scaleX(1.2) scaleY(1);\n    transition: transform theme.$simxTransitionSpeedDefault;\n\n    .simx-list-filter-panel.simx-expanded & {\n      transform: scaleX(1.2) scaleY(-1);\n    }\n\n    path {\n      fill: colors.$simxColorLightNeutralDarker;\n    }\n  }\n}\n\n.simx-list-filter-panel--body-toggle--heading {\n  flex-grow: 1;\n  padding: 8px;\n\n  .simx-filter-value {\n    font-weight: 600;\n  }\n}\n\n.simx-list-filter-panel--body {\n  padding: 0 12px;\n}\n\n.simx-list-filter-panel--body-inner {\n  border-top: solid 1px colors.$simxColorControlBorder;\n  padding: 12px 0;\n}\n\n.simx-list-filter-panel--filter-attribute-block {\n  display: flex;\n    align-items: center;\n  margin: 10px 0;\n  &:first-of-type {\n    margin-top: 0;\n  }\n  &:last-of-type {\n    margin-bottom: 0;\n  }\n}\n\n.simx-list-filter-panel--filter-attribute-label-block {\n  flex-grow: 0;\n  flex-shrink: 0;\n  padding-right: 12px;\n  width: 20%;\n}\n\n.simx-list-filter-panel--filter-attribute-label {\n  display: block;\n  font-size: 0.875rem;\n  font-weight: 600;\n}\n\n.simx-list-filter-panel--filter-attribute-value-block {\n  flex-grow: 1;\n  font-size: 0.875rem;\n  padding-left: 12px;\n\n  .simx-text-input {\n    font-size: 0.875rem;\n    width: 100%;\n  }\n  .simx-select {\n    font-size: 0.875rem;\n  }\n}\n\n.simx-list-filter-panel--filter-attribute-action-block {\n  padding-left: 12px;\n  width: 34px;\n}\n","$simxFontDefault: 'Open Sans';\n$simxFontGraphic: 'Quicksand';\n","@use 'sass:color';\n\n$simxColorBrightAccent:         rgb(229, 0, 44);  // Red\n$simxColorDarkAccent:           rgb(54, 47, 65);  // Purple\n$simxColorBrightGreen:          rgb(0, 201, 133);\n$simxColorMustard:              rgb(255, 177, 0);\n\n$simxColorDarkAccentMedium:     color.adjust($simxColorDarkAccent, $lightness: 6%);\n$simxColorDarkAccentLight:      color.adjust($simxColorDarkAccent, $lightness: 53%);\n$simxColorDarkNeutral:          rgb(21, 19, 25);\n$simxColorDarkNeutralLight:     color.adjust(color.adjust($simxColorDarkNeutral, $saturation: -7%), $lightness: 76%);\n$simxColorLightNeutral:         rgb(230, 235, 235);\n$simxColorLightNeutralLight:    color.adjust($simxColorLightNeutral, $lightness: 5%);\n$simxColorLightNeutralDark:     color.adjust($simxColorLightNeutral, $lightness: -12.5%);\n$simxColorLightNeutralDarker:   color.adjust($simxColorLightNeutral, $lightness: -25%);\n$simxColorLightNeutralDarkest:  color.adjust($simxColorLightNeutral, $lightness: -37.5%);\n$simxColorWhite:                rgb(255, 255, 255);\n\n$simxColorTextDefault:          $simxColorDarkNeutral;\n$simxColorTextLight:            rgb(166, 167, 169);\n$simxColorTextInvert:           rgba(255, 255, 255, 0.95);\n$simxColorTextOverDarkAccent:   rgba($simxColorWhite, 0.95);\n\n$simxColorControlBackground:    $simxColorWhite;\n$simxColorControlBorder:        $simxColorLightNeutralDark;\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
